import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositorySafetyMessages } from "../../domain/repositories/repository-safety-messages";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormCreateSafetyMessage } from "../molecules/form-create-safety-message";
import { FormUpdateSafetyMessage } from "../molecules/form-update-safety-message";

export type ListCommandButtonsSafetyMessagesProps = Omit<
    ListCommandButtonsProps<RepositorySafetyMessages>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsSafetyMessages extends React.Component<ListCommandButtonsSafetyMessagesProps> {
    constructor(props: ListCommandButtonsSafetyMessagesProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteSafetyMessages(ids: UUID[]): Promise<void> {
        await store.repositorySafetyMessages.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                createButtonText={store.i18n.t("listSafetyMessages.button.add")}
                createDialogTitle={store.i18n.t("formCreateSafetyMessage.title")}
                updateDialogTitle={store.i18n.t("formUpdateSafetyMessage.title")}
                updateForm={FormUpdateSafetyMessage}
                createForm={FormCreateSafetyMessage}
                {...this.props}
                listState={store.serviceListStates.safetyMessages}
                onDelete={this.deleteSafetyMessages}
            />
        );
    }
}
